import { getBackgroundToken, getBorderToken, getTextToken } from "../fundations/palette/colorTokens";
import { Corner8 } from "../fundations/shape/corners";
export const Snackbar = {
    MuiSnackbarContent: {
        styleOverrides: {
            message: ({ theme })=>({
                    padding: theme.spacing(0)
                }),
            action: ({ theme })=>({
                    gap: theme.spacing(1.5),
                    padding: theme.spacing(0)
                }),
            root: ({ theme })=>({
                    backgroundColor: "transparent",
                    color: getTextToken("textPrimary", theme),
                    padding: theme.spacing(2)
                })
        }
    },
    MuiSnackbar: {
        styleOverrides: {
            root: ({ theme })=>({
                    backgroundColor: getBackgroundToken("backgroundQuaternary", theme),
                    borderRadius: Corner8,
                    borderColor: getBorderToken("border200", theme),
                    borderWidth: "1px",
                    borderStyle: "solid"
                })
        }
    }
};

//# sourceMappingURL=Snackbar.js.map